// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2IY_w","title":"AfterFrontImage_title__4Yjml"};